<template>
  <div class="public-address-selector">
    <el-select
      :value="completeAddress"
      :popper-append-to-body="false"
      popper-class="el-select-popper"
      :placeholder="placeholderKey"
      ref="selector"
      @visible-change="handlerVisibleChange"
      class="address-select-class"
      :clearable="isClearable"
      @clear="handleClearAddress"
      :disabled="disabled"
    >
      <template slot="empty">
        <el-tabs v-model="tabName" type="border-card" @tab-click="tabClick">
          <el-tab-pane name="country" v-if="hasShowCountryTabs">
            <span title="国家" slot="label">{{ '国家' }}</span>
            <div id="country-list-wrapper">
              <div
                class="country-groups"
                v-for="(group, groupKey) in countryListData"
                :key="groupKey"
              >
                <div class="groups-box">
                  <span>{{ groupKey }}</span>
                  <hr class="country-group-divider" />
                </div>
                <ul>
                  <li
                    v-for="item in group"
                    :key="item.id"
                    :class="{
                      active: addressData.country_id == item.id,
                    }"
                    @click="selectOption('country', item)"
                  >
                    {{ item.cname }}
                  </li>
                </ul>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="province" v-if="province_list?.length > 0">
            <span title="省（州）" slot="label">{{ '省（州）' }}</span>
            <ul class="no-search-input">
              <li
                v-for="item in province_list"
                :key="item.id"
                :class="{ active: addressData.province_id == item.id }"
                @click="selectOption('province', item)"
              >
                {{ item.cname }}
              </li>
            </ul>
          </el-tab-pane>
          <el-tab-pane name="city" v-if="city_list?.length > 0">
            <span title="市" slot="label">{{ '市' }}</span>
            <ul class="no-search-input">
              <li
                v-for="item in city_list"
                :key="item.id"
                :class="{ active: addressData.city_id == item.id }"
                @click="selectOption('city', item)"
              >
                {{ item.cname }}
              </li>
            </ul>
          </el-tab-pane>
          <el-tab-pane name="district" v-if="district_list?.length > 0">
            <span title="区" slot="label">{{ '区' }}</span>
            <ul class="no-search-input">
              <li
                v-for="item in district_list"
                :key="item.id"
                :class="{ active: addressData.district_id == item.id }"
                @click="selectOption('district', item)"
              >
                {{ item.cname }}
              </li>
            </ul>
          </el-tab-pane>
        </el-tabs>
      </template>
    </el-select>
  </div>
</template>
<script>
// api
import {
  getCountry,
  getProvinces,
  getCity,
  getDistrict,
} from '@/api/public_port.js';
export default {
  props: {
    placeholderKey: {
      type: String,
      default: '请选择',
    },
    /**
     * 是否需要自定义
     * 使用了这个之后，所有数据及操作都是自定义
     */
    isWhetherToCustomize: {
      type: Boolean,
      default: false,
    },
    // 自定义TabName
    customizeChangeTab: {
      type: String,
      default: '',
    },
    // 自定义国家列表
    customizeCountryList: {
      type: Object,
      default: () => {},
    },
    // 自定义省列表
    customizeProvinceList: {
      type: Array,
      default: () => [],
    },
    // 需要被过滤的数据
    needFilterAddressList: {
      type: Object,
      default: () => {
        return {
          country: new Set([44]),
        };
      },
    },
    // 数据回显
    initAddressData: {
      type: Object,
      default: () => {
        // return {
        //   country: "",
        //   country_id: "",
        //   province: "",
        //   province_id: "",
        //   city: "",
        //   city_id: "",
        //   district: "",
        //   district_id: "",
        // };
      },
    },
    // 是否显示输入框上国家的展示
    hasShowInputCountry: {
      type: Boolean,
      default: true,
    },
    // 地址筛选输入框长度
    selectInputWidth: {
      type: [Number, String],
      default: '',
    },
    // 是否能清除
    isClearable: {
      type: Boolean,
      default: false,
    },
    /**
     * 控制能选中的末级（默认为所能达到的最后一级）
     * onlyCountry - 只可选国家
     * onlyCountryNext - 国家或国家的下一个作为最后一个
     * lastLevelCity - 能到的最后一级为市
     */
    canSelectedLevel: {
      type: String,
      default: '',
    },
    // 是否需要对单个国家进行处理
    isNeedHandlerSingleCountry: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      addressConfig: ['country', 'province', 'city', 'district'],
      tabName: 'country',
      hasShowCountryTabs: true,
      country_list: {},
      province_list: [],
      city_list: [],
      district_list: [],
      // 选中的数据
      addressData: {
        country: '',
        country_id: '',
        countryInfo: {},
        province: '',
        province_id: '',
        provinceInfo: {},
        city: '',
        city_id: '',
        cityInfo: {},
        district: '',
        district_id: '',
        districtInfo: {},
      },

      isLast: false,
    };
  },
  computed: {
    completeAddress() {
      const config = [...this.addressConfig];
      if (!this.hasShowInputCountry) {
        config.splice(0, 1);
      }
      let str = '';
      for (const item of config) {
        if (this.addressData[item]) {
          if (!str) {
            str = this.addressData[item];
          } else {
            str += '/' + this.addressData[item];
          }
        }
      }
      return str;
    },

    tabHeaderWidth() {
      let width = 100;
      let tabNum = 3;

      let totalWidth = width * tabNum;

      if (
        this.selectInputWidth &&
        Number(this.selectInputWidth || 0) > Number(totalWidth)
      ) {
        return this.selectInputWidth + 'px';
      }

      return totalWidth + 'px';
    },

    countryListData() {
      // 获取对象的所有键
      const sortedKeys = Object.keys(this.country_list).sort();
      const sortedObj = {};
      // 按排序后的键重新构建对象
      sortedKeys.forEach(key => {
        sortedObj[key] = this.country_list[key];
      });
      return sortedObj;
    },

    selectInput() {
      let inputWidth = 200;
      if (this.selectInputWidth && this.selectInputWidth != 0) {
        inputWidth = this.selectInputWidth;
      }
      return inputWidth + 'px';
    },
  },
  watch: {
    customizeCountryList: {
      handler(newVal) {
        if (this.isWhetherToCustomize) {
          this.country_list = {...newVal};
          this.handleIfOnlyCountry(this.country_list);
        }
      },
      deep: true,
    },
    customizeProvinceList: {
      handler(newVal) {
        if (this.isWhetherToCustomize) {
          this.province_list = [...newVal];
        }
      },
      deep: true,
    },
    customizeChangeTab(newVal) {
      if (this.isWhetherToCustomize) {
        this.tabName = newVal;
      }
    },
    initAddressData: {
      handler(newVal) {
        // this.needInitAddressData(newVal);
      },
      deep: true,
    },
  },
  methods: {
    // 数据
    async getCountry() {
      return new Promise(async (resolve, reject) => {
        const options = {
          is_initial_group: 1,
        };
        try {
          let res = await getCountry(options);
          if (res?.errcode == 0) {
            const newCountryArr = this.findCountryDataById(
              res?.data || [],
              this.needFilterAddressList?.country
            );

            this.country_list = newCountryArr;
            if (this.isNeedHandlerSingleCountry) {
              this.handleIfOnlyCountry(this.country_list);
            }
            resolve('country');
          }
        } catch (error) {
          console.log(error);
          reject();
        }
      });
    },

    async getProvinces() {
      // #memo 避免重复请求，无上级 id 不请求省份数据
      if (!this.addressData?.country_id) return;
      return new Promise(async (resolve, reject) => {
        try {
          const options = {
            id: this.addressData.country_id,
          };
          let res = await getProvinces(options);
          if (res?.errcode == 0) {
            let newList = this.findAllDataById(
              res?.data || [],
              this.needFilterAddressList?.province
            );
            this.province_list = newList || [];
            if (this.province_list?.length > 0) {
              this.changeTab('province');
            } else {
              this.closeDropdown();
            }
            resolve('province');
          }
        } catch (err) {
          console.error(err);
        }
      });
    },

    async getCity() {
      return new Promise(async (resolve, reject) => {
        try {
          const options = {
            id: this.addressData.province_id,
          };
          let res = await getCity(options);
          if (res?.errcode == 0) {
            let newList = this.findAllDataById(
              res?.data || [],
              this.needFilterAddressList?.city
            );
            this.city_list = newList;
            if (this.city_list?.length > 0) {
              this.changeTab('city');
            } else {
              this.closeDropdown();
            }
            resolve('city');
          }
        } catch (err) {
          console.error(err);
        }
      });
    },

    async getDistrict() {
      return new Promise(async (resolve, reject) => {
        try {
          const options = {
            id: this.addressData.city_id,
          };
          let res = await getDistrict(options);
          if (res?.errcode == 0) {
            let newList = this.findAllDataById(
              res?.data || [],
              this.needFilterAddressList?.district
            );
            this.district_list = newList;
            if (this.district_list?.length > 0) {
              this.changeTab('district');
            } else {
              this.closeDropdown();
            }
            resolve('district');
          }
        } catch (err) {
          console.error(err);
        }
      });
    },

    // 当仅有一个国家的情况
    handleIfOnlyCountry(countryData) {
      const result = [];
      for (const key in countryData) {
        if (countryData?.[key]?.length > 0) {
          result.push(...countryData?.[key]);
        }
      }
      if (result?.length === 1) {
        this.selectOption('country', result[0]);
        this.hasShowCountryTabs = false;
      }
    },

    async needInitAddressData(initAddressData) {
      const config = [...this.addressConfig];
      for (let i = 0; i < config?.length; i++) {
        const addressConfig = config[i];
        if (
          initAddressData?.[addressConfig + '_id'] &&
          initAddressData?.[addressConfig]
        ) {
          const options = {
            cname: initAddressData[addressConfig],
            id: initAddressData[addressConfig + '_id'],
          };
          await this.selectOption(addressConfig, options);
          this.tabName = addressConfig;
          continue;
        }
      }
    },

    // 查找国家函数
    findCountryDataById(data, targetIds) {
      if (!targetIds) return data || [];
      const result = {};
      if (targetIds?.size == 0) return data || [];
      // 遍历数据分组
      for (let i = 0; i < data?.length; i++) {
        const group = data?.[i] || {};
        let curGroupList = group?.list;
        if (curGroupList?.length > 0) {
          const filterArr = curGroupList?.filter(item =>
            targetIds?.has(item?.id)
          );
          if (filterArr?.length > 0) {
            result[group.initial] = filterArr || [];
          }
        }
        continue;
      }
      return result || {};
    },

    // 查找函数
    findAllDataById(data, targetIds) {
      if (!targetIds) return data || [];
      const result = new Map();
      if (targetIds?.size == 0) return data || [];
      for (let i = 0; i < data?.length; i++) {
        let info = data[i];
        if (targetIds.has(info?.id) && !result.has(info?.id)) {
          result.set(info.id, info);
        }
      }
      return [...result.values()];
    },

    // 用户行为
    changeTab(val) {
      this.tabName = val;
    },
    tabClick() {
      if (this.isWhetherToCustomize) {
        this.$emit('tab-click', this.tabName);
      }
    },
    // 点击地址互动
    async selectOption(addressType, item) {
      this.isLast = false;
      if (this.isWhetherToCustomize) {
        this.$emit('selectOption', addressType, item);
        return;
      }
      this.clearAddressData(addressType);
      this.addressData[addressType] = item?.cname;
      this.addressData[addressType + '_id'] = item?.id;
      this.addressData[addressType + 'Info'] = item;

      const options = {
        country: 'getProvinces',
        province: 'getCity',
        city: 'getDistrict',
      };

      const curOptions = options?.[addressType] || '';

      if (curOptions) {
        if (this.canSelectedLevel && this.handlerCanSelectLevel(addressType)) {
          this.closeDropdown();
          return;
        }

        await this[curOptions]();
      } else {
        this.closeDropdown();
      }
    },

    // 处理到达某一级就筛选完毕操作
    handlerCanSelectLevel(addressType) {
      let isFinish = false;
      const config = {
        country: new Set(['onlyCountry']),
        province: new Set(['onlyCountryNext']),
        city: new Set(['onlyCountryNext', 'lastLevelCity']),
      };

      isFinish = config?.[addressType]?.has(this.canSelectedLevel);

      return isFinish;
    },

    closeDropdown() {
      this.isLast = true;
      this.$refs.selector && this.$refs.selector.blur(); // 选择器的尖角符号向下
    },

    handlerVisibleChange(event) {
      if (event) return;
      if (!this.isWhetherToCustomize) {
        this.$emit('updata', this.addressData, this.isLast);
      } else {
        this.$emit('visible-change', event);
      }
    },

    clearAddressConfig(type) {
      this.addressData[type] = '';
      this.addressData[type + '_id'] = '';
      this.addressData[type + 'Info'] = {};
    },

    clearAddressData(addressType) {
      let config = [...this.addressConfig];
      let index = config?.findIndex(item => item == addressType);
      const result =
        index !== -1 ? config.slice(index + 1) : [...this.addressConfig];
      for (const item of result) {
        this.clearAddressConfig(item);
        this[item + '_list'] = [];
      }
    },

    needClearAddressData(addressType) {
      let config = [...this.addressConfig];
      let index = config?.findIndex(item => item == addressType);
      const result =
        index !== -1 ? config.slice(index + 1) : [...this.addressConfig];

      for (const item of result) {
        this.clearAddressConfig(item);
        this[item + '_list'] = [];
      }
      this.clearAddressConfig(addressType);

      this.changeTab(addressType);
      this.$emit('updata', this.addressData, false);
    },

    // 操作清空按钮
    handleClearAddress() {
      if (this.isWhetherToCustomize) {
        this.$emit('clear');
        return;
      }
      let config = [...this.addressConfig];
      let needClearConfigType = '';
      for (let i = 0; i < config?.length; i++) {
        const configStr = config[i];
        const filterConfig = this.needFilterAddressList?.[configStr];
        if (filterConfig && filterConfig?.size == 0) {
          needClearConfigType = configStr;
          break;
        } else if (!filterConfig && configStr) {
          needClearConfigType = configStr;
          break;
        }
      }
      console.log(needClearConfigType, 'needClearConfigType');
      this.needClearAddressData(needClearConfigType);
    },
  },
  mounted() {
    this.$nextTick(async () => {
      if (!this.isWhetherToCustomize) {
        await this.getCountry();
        this.needInitAddressData(this.initAddressData);
      } else {
        this.addressData = this.initAddressData;
      }
    });

    // this.handleInputSearchCountry = this._debounce(this.searchCountry, 500);
  },
  beforeDestroy() {
    // this.resetData();
  },
};
</script>
<style lang="scss" scoped>
$tab-width: 100px;
$select-height: 40px;
$highlight-color: #ff7802;

@mixin pretty-scrollbar {
  // 滚动条美化
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    width: 6px;
    background: rgba(#101f1c, 0.1);
    // -webkit-border-radius: 2em;
    // -moz-border-radius: 2em;
    // border-radius: 2em;
    -webkit-border-radius: 7px;
    -moz-border-radius: 7px;
    border-radius: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(144, 147, 153, 0.5);
    background-clip: padding-box;
    min-height: 28px;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
    transition: background-color 0.3s;
    cursor: pointer;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: rgba(144, 147, 153, 0.3);
  }
  // 滚动条美化
}

@mixin elTabStyle {
  // 处理tabs位置问题
  ::v-deep .el-tabs {
    visibility: visible;
    position: absolute;
    top: -8px;
    left: -5px;
    z-index: 2; // 必须比原本的下拉菜单大

    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    min-width: v-bind(tabHeaderWidth);
    li{
      line-height: normal;
    }
    * {
      font-size: 14px;
      color: #666;
    }
  }

  ::v-deep .el-tabs--border-card > .el-tabs__header {
    border: 0px;

    .el-tabs__nav-scroll {
      height: 40px;
      background: #f2f2f2;
    }
  }
  ::v-deep .el-tabs--border-card > .el-tabs__content {
    padding-bottom: 10px;
  }
  // 解决高亮标签页两侧有1px缝隙
  ::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    border-left-color: transparent;
    border-right-color: transparent;
  }
  // 调整标签页宽度，宽度相同且文本居中
  ::v-deep .el-tabs__item {
    width: $tab-width;
    height: 100%;
    text-align: center;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  // 解决“城市”标签页头右侧有1px缝隙
  ::v-deep .el-tabs__item:nth-last-of-type(1) {
    width: $tab-width + 1;
  }
  // 隐藏标签页前后的滑动提示箭头
  ::v-deep .el-tabs__nav-prev,
  .el-tabs__nav-next {
    display: none;
  }
  ::v-deep
    .el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item
    + .el-tabs__item {
    margin-left: 0px;
  }

  ::v-deep .el-tabs__content {
    padding-right: 2px; // 解决滚动条不贴右边问题（有 2px 缝隙）
    padding-top: 10px;
    height: 255px;
  }
  ::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    color: #808080;
  }
  // 解决点击和悬浮标签页，标签页文字蓝色高亮问题
  ::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active,
  ::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
    color: #4d4d4d;
  }
  ::v-deep .el-tabs__item.is-top {
    background-color: #f2f2f2;
    color: #808080;
  }
  ::v-deep .el-tabs__item.is-active {
    background-color: #ffffff;
    color: #4d4d4d;
  }
}
.public-address-selector {
  position: relative;
  * {
    border: 0px;
  }
  ul {
    padding-left: 1em; // 选项名称距离左边的距离
  }

  li {
    list-style-type: none;
    padding-top: 5px;
    padding-bottom: 5px;
    cursor: pointer;
    &:hover {
      color: $highlight-color;
    }
  }
  li.active,
  span.active {
    color: $highlight-color;
  }

  @include pretty-scrollbar;

  @include elTabStyle;

  .address-select-class {
    ::v-deep .el-input {
      width: v-bind(selectInput);
    }
  }

  #country-list-wrapper {
    height: 240px;
    overflow: auto;

    &::-webkit-scrollbar-track {
      background: none;
    }
    .country-groups {
      & > span {
        color: #666;
        padding-right: 5px;
        margin-top: 5px;
      }
      & > span.active {
        color: $highlight-color;
      }
      // 国家按拼音分组，分组的水平分割线
      .groups-box {
        display: inline-flex;
        .country-group-divider {
          border: 1px solid #e6e6e6;
          display: inline-block;
          width: calc(v-bind(tabHeaderWidth) - 50px);

          margin: auto;
        }
      }
    }
  }

  .no-search-input {
    height: 240px;
    overflow: auto;
    padding-left: 5px;

    li {
      line-height: 24px;
    }
    &::-webkit-scrollbar-track {
      background: none;
    }
  }
}
</style>
